import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	Output,
} from '@angular/core';

import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';

@Component({
	selector: 'maintenance-section',
	imports: [MatExpansionModule, MatIconModule],
	templateUrl: './maintenance-section.component.html',
	styleUrls: ['./maintenance-section.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaintenanceSectionComponent {
	@Input() title: string;
	@Input() expanded: boolean;
	@Input() showSectionIcon = true;
	@Output() closed = new EventEmitter<void>();
	@Output() opened = new EventEmitter<void>();
}
